import React, { useState } from 'react'
import { Form, Card, Typography, Button, Space, message, Divider } from 'antd'
import { ArrowLeftOutlined, CheckOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import CreditNoteForm from './CreditNoteForm'
import { createCreditNote } from '../../backend-integration/api/creditNotes'
import coreReducer from '../../../../core/utils/reducer'

const { Title } = Typography

const CreditNoteWrapper = ({ preSelectedPatient, tabKey }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      await createCreditNote({
        ...values,
        patientId: preSelectedPatient._id,
        billingId: preSelectedPatient.billingId
      })

      message.success('Credit note created successfully')

      // Close the current tab
      dispatch(coreReducer.actions.closeTab(tabKey))
    } catch (error) {
      console.error('Failed to create credit note:', error)
      message.error('Failed to create credit note')
    } finally {
      setLoading(false)
    }
  }

  const handleGoBack = () => {
    // Close the current tab
    dispatch(coreReducer.actions.closeTab(tabKey))
  }

  return (
    <Card>
      <div style={{ marginBottom: 16 }}>
        <Button type='text' icon={<ArrowLeftOutlined />} onClick={handleGoBack} style={{ marginBottom: 8 }}>
          Back to Account
        </Button>
        <Title level={3} style={{ margin: 0 }}>
          Create Credit Note
        </Title>
        <p style={{ color: '#666', margin: '8px 0 0 0' }}>
          Patient: {preSelectedPatient.name} (ID: {preSelectedPatient.billingId})
        </p>
      </div>

      <Form form={form} layout='vertical' onFinish={handleSubmit}>
        <CreditNoteForm form={form} preSelectedPatient={preSelectedPatient} />

        <Divider />

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Space>
            <Button onClick={handleGoBack}>Cancel</Button>
            <Button type='primary' htmlType='submit' loading={loading} icon={<CheckOutlined />}>
              Create Credit Note
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default CreditNoteWrapper
